import React from 'react';

import InhousePdfViewer from '../inhouse/InhousePdfViewer';

interface KnowledgeDocumentViewerProps {
  url: string;
  fileName: string;
  pageNumber?: number;
}

function withPdfPage(url: string, pageNumber?: number): string {
  if (!pageNumber || pageNumber < 1) return url;
  const cleanUrl = url.replace(/#.*$/, '');
  return `${cleanUrl}#page=${pageNumber}`;
}

const KnowledgeDocumentViewer: React.FC<KnowledgeDocumentViewerProps> = ({ url, fileName, pageNumber }) => (
  <InhousePdfViewer url={withPdfPage(url, pageNumber)} fileName={fileName} />
);

export default KnowledgeDocumentViewer;
